import Vue from "vue";

export const mutations = {
    authenticated(state, value) {
        state.authenticated = value;
    },
    setFreeze(state, value) {
        state.freeze = value;
    },
    setCartData(state, value) {
        state.cartData = value
    },
    removeCartItemFromCartData(state, pim_id) {
        const categoryIndex = state.cartData.items.findIndex(category => category.items.some(item => item.pim_id === pim_id))

        if (categoryIndex !== -1) {
            const itemIndex = state["cartData"]["items"][categoryIndex]["items"].findIndex(item => item.pim_id === pim_id)

            Vue.delete(state["cartData"]["items"][categoryIndex]["items"], itemIndex)

            if (state["cartData"]["items"][categoryIndex]["items"].length === 0) {
                Vue.delete(state["cartData"]["items"], categoryIndex)
            }
        }
    },
    setCartFanboxItems(state, items) {
        Vue.set(state, 'cartFanboxItems', items)
    },
    setCartSelectFanbox(state, payload) {
        state.cartSelectFanbox = payload
    },
    setCartFanboxThreshold(state, payload) {
        state.cartFanboxThreshold = payload
    },
    addCartErrorItem(state, pim_id) {
        if (state.cartErrorItems.indexOf(pim_id) === -1) {
            state.cartErrorItems.push(pim_id)
        }
    },
    removeCartErrorItem(state, pim_id) {
        if (state.cartErrorItems.indexOf(pim_id) !== -1) {
            state.cartErrorItems.splice(state.cartErrorItems.indexOf(pim_id), 1);
        }
    },
    changeCartOrderQuantity(state, payload) {
        Vue.set(state.cartOrderQuantity, payload.pim_id, payload.quantity)
    },
    removeCartOrderQuantity(state, pim_id) {
        Vue.delete(state.cartOrderQuantity, pim_id);
    }
};
